import { saveAs } from 'file-saver';

export type DebugMessageType = 'LOG' | 'ERROR';

if (typeof window !== 'undefined') {
  window.debugEnabled = false;
  window.debugMessages = [];
}

function formatDate(date: Date): string {
  const pad = (value: number, length = 2) => String(value).padStart(length, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}:${pad(date.getMilliseconds(), 3)}`;
}

function formatValue(value: unknown): string {
  if (value instanceof Error) {
    return value.stack || `${value.name}: ${value.message}`;
  }
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value) ?? String(value);
  } catch {
    return String(value);
  }
}

function write(type: DebugMessageType, values: unknown[]): void {
  if (!window.debugEnabled) {
    return;
  }
  const level = type === 'LOG' ? 'LOG  ' : 'ERROR';
  window.debugMessages.push(`${level},${formatDate(new Date())},${values.map(formatValue).join(' ')}`);
}

export function log(...values: unknown[]): void {
  console.log(...values);
  write('LOG', values);
}

export function error(...values: unknown[]): void {
  console.error(...values);
  write('ERROR', values);
}

export function downloadDebugMessages(): boolean {
  if (window.debugMessages.length === 0) {
    return false;
  }

  const [date, time] = formatDate(new Date()).split(' ');
  const [hours, minutes, seconds, milliseconds] = time.split(':');
  const filename = `debug_${date}_${hours}_${minutes}_${seconds}:${milliseconds}.txt`;
  saveAs(new Blob([window.debugMessages.join('\n')], { type: 'text/plain;charset=utf-8' }), filename);
  return true;
}
